export const MeetingErrorType = {
  bugParticipantCameraFeed: {
    data: "There was an issue displaying the camera feed from a participant. Please try again.",
    type: 'ErrorOccured',
    errId: 'ERR01',
  },
  bugLocalVideoStream: {
    data: "There was an issue with your camera feed. Please check your camera and try again.",
    type: 'ErrorOccured',
    errId: 'ERR02',
  },
  bugLocalScreenShareStream: {
    data: "There was an issue sharing your screen. Please try again.",
    type: 'ErrorOccured',
    errId: 'ERR03',
  },
  bugCameraNotFound: {
    data: "Your camera couldn't be detected. Please ensure it's properly connected and try again.",
    type: 'ErrorOccured',
    errId: 'ERR04',
  },
  bugAddingToChatList: {
    data: "There was an issue adding you to the chat list. Please refresh or try again later.",
    type: 'ErrorOccured',
    errId: 'ERR05',
  },
  bugturnOnCamera: {
    data: "There was an issue starting your video. Please check your camera settings and try again.",
    type: 'ErrorOccured',
    errId: 'ERR06',
  },
  bugturnOnMicroPhone: {
    data: "There was an issue turning on your microphone. Please check your microphone settings and try again.",
    type: 'ErrorOccured',
    errId: 'ERR07',
  },
  bugturnOffMicroPhone: {
    data: "There was an issue turning off your microphone. Please check your settings and try again.",
    type: 'ErrorOccured',
    errId: 'ERR08',
  },
  bugStopScreenShareStream: {
    data: "There was an issue stopping the screen share. Please try stopping it again.",
    type: 'ErrorOccured',
    errId: 'ERR09',
  },
  bugturnOffCamera: {
    data: "There was an issue stopping your video. Please check your camera settings and try again.",
    type: 'ErrorOccured',
    errId: 'ERR010',
  },
  MessageSent: {
    data: "Your message couldn't be sent. Please try sending it again.",
    type: 'ErrorOccured',
    errId: 'ERR011',
  },
  screenShareOff: {
    data: "There was an issue removing your screen share. Please try again or click 'OK' to remove your video stream.",
    type: 'ErrorOccured',
    errId: 'ERR012',
  },
  bugVideoFeedOff: {
    data: "There was an issue removing your video stream. Please try again or click 'OK' to remove it.",
    type: 'ErrorOccured',
    errId: 'ERR013',
  },
  bugMessageNotSent: {
    data: "Your message couldn't be sent. Please try resending it.",
    type: 'ErrorOccured',
    errId: 'ERR014',
  },
  bugLeavingMeeting:{
    data: "There was an issue removing you from the meeting. Please refresh the page to leave.",
    type: 'ErrorOccured',
    errId: 'ERR015',
  },
  bugEndingMeeting:{
    data: "There was an issue ending the meeting. Please refresh the page to exit.",
    type: 'ErrorOccured',
    errId: 'ERR016',
  },
  bugPreviewScreenTurnOnCamera:{
    data: "Your camera couldn't be turned on. Please check your camera and try again.",
    type: 'ErrorOccured',
    errId: 'ERR017',
  },
  bugPreviewScreenTurnOffCamera:{
    data: "Your camera couldn't be turned off manually. Please refresh the page to turn off the camera.",
    type: 'ErrorOccured',
    errId: 'ERR018',
  },
  bugNoAccessToMic:{
    data: "Please reset your browser permissions to grant access to your microphone.",
    type: 'ErrorOccured',
    errId: 'ERR019',
  },
  bugNoAccessToCam:{
    data: "Please reset your browser permissions to grant access to your camera.",
    type: 'ErrorOccured',
    errId: 'ERR020',
  },
  bugNoAccessToCamAndMic:{
    data: "Please reset your browser permissions to grant access to both your camera and microphone.",
    type: 'ErrorOccured',
    errId: 'ERR021',
  },
  bugMuteParticularParticipant:{
    data: "There was an issue muting the particular participant. Kindly please try again.",
    type: 'ErrorOccured',
    errId: 'ERR022',
  },
  bugMuteAllParticipant:{
    data: "There was an issue muting all the participant. Kindly please try again.",
    type: 'ErrorOccured',
    errId: 'ERR023',
  },
  bugParticipantMicroPhoneFeed: {
    data: "There was an issue with Participant Audio. Please try again.",
    type: 'ErrorOccured',
    errId: 'ERR024',
  }

};
